import { Controller } from "@hotwired/stimulus"

/**
 * SelectionController - Maneja la selección múltiple de elementos con checkboxes
 * Conecta a data-controller="selection"
 */
export default class extends Controller {
  static targets = ["checkbox", "counter", "deleteButton", "selectAll", "selectedIds", "zoneIds"]

  connect() {
    this.updateUI()
  }

  toggle() {
    this.updateUI()
  }

  toggleAll(event) {
    const isChecked = event.target.checked
    
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    
    this.updateUI()
  }

  updateUI() {
    const selectedIds = this.getSelectedIds()
    const selectedCount = selectedIds.length


    this.updateHiddenFields(selectedIds)
    this.updateCounters(selectedCount)
    this.updateActionButton(selectedCount)
    this.updateSelectAllState()
  }

  updateHiddenFields(selectedIds) {
    const idsString = selectedIds.join(',')
    
    this.selectedIdsTargets.forEach(target => target.value = idsString)
    this.zoneIdsTarget.value = selectedIds.join(',')
  }

  updateCounters(selectedCount) {
    const counterText = this.getCounterText(selectedCount)
    
    // Actualizar contador en la barra de acciones
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = counterText
    }
    
    // Actualizar el contador en cada modal de acción masiva (puede haber varios).
    document.querySelectorAll('.selected-count').forEach((el) => {
      el.textContent = selectedCount
    })
  }

  updateActionButton(selectedCount) {
    if (!this.hasDeleteButtonTarget) return
    
    this.deleteButtonTarget.classList.toggle('d-none', selectedCount === 0)
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return

    const totalCheckboxes = this.checkboxTargets.length
    const selectedCheckboxes = this.checkboxTargets.filter(cb => cb.checked).length
    const allSelected = totalCheckboxes === selectedCheckboxes && totalCheckboxes > 0
    const someSelected = selectedCheckboxes > 0 && selectedCheckboxes < totalCheckboxes

    // Mantiene sincronizados todos los "seleccionar todo" (cabecera en escritorio
    // y barra en móvil), no solo el primero.
    this.selectAllTargets.forEach(target => {
      target.checked = allSelected
      target.indeterminate = someSelected
    })
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
      .filter(Boolean) // Filtrar valores vacíos
  }

  getCounterText(count) {
    if (count === 0) return 'Ningún elemento seleccionado'
    if (count === 1) return '1 elemento seleccionado'
    return `${count} elementos seleccionados`
  }
}
